"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/casting/Metal-Casting/applications-of-metal-casting.webp";

const ITEMS = [
	{ titleKey: "applicationsItem1Title", descKey: "applicationsItem1Desc" },
	{ titleKey: "applicationsItem2Title", descKey: "applicationsItem2Desc" },
	{ titleKey: "applicationsItem3Title", descKey: "applicationsItem3Desc" },
] as const;

const CheckCircleIcon = () => (
	<svg className="mt-1 h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="8" fill="#78b63f" />
		<path
			d="M6.4 10.2L8.7 12.4L13.6 7.6"
			stroke="white"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function MetalCastingApplications() {
	const t = useTranslations("new-metal-casting");

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1fr_1.05fr] lg:gap-10 xl:gap-14">
					<div>
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("applicationsTitle")}
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:text-base">
							{t("applicationsDesc")}
						</p>
						<div className="space-y-5">
							{ITEMS.map((item) => (
								<div key={item.titleKey}>
									<p className="mb-2 flex items-start gap-3">
										<CheckCircleIcon />
										<span className="text-base font-semibold leading-tight text-black sm:text-lg">
											{t(item.titleKey)}
										</span>
									</p>
									<p className="pl-8 text-sm leading-relaxed text-black md:text-base">{t(item.descKey)}</p>
								</div>
							))}
						</div>
					</div>

					<div className="relative aspect-[23/20] w-full overflow-hidden bg-gray-100">
						<Image
							src={encodeURI(IMAGE_SRC)}
							alt={t("applicationsImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 52vw"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
